import { render, staticRenderFns } from "./EditDocumentTemplate.vue?vue&type=template&id=472b09f0"
import script from "./EditDocumentTemplate.vue?vue&type=script&lang=js"
export * from "./EditDocumentTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EditDocumentTemplate.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('472b09f0')) {
      api.createRecord('472b09f0', component.options)
    } else {
      api.reload('472b09f0', component.options)
    }
    module.hot.accept("./EditDocumentTemplate.vue?vue&type=template&id=472b09f0", function () {
      api.rerender('472b09f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/clients/views/EditDocumentTemplate.vue"
export default component.exports